<script>
import { mapGetters } from "vuex";
import { Pie } from "vue-chartjs";
import Options from "@/options";

export default {
  extends: Pie,
  computed: {
    data() {
      if (!this.assets.length) {
        return [1];
      }
      return this.assets.map((asset) => asset.share);
    },
    labels() {
      return this.assets.map((asset) => asset.name);
    },
    colors() {
      if (!this.assets.length) {
        return ["#8da3ad"];
      }
      return Options.chartColors.map((color, key) => {
        return this.assets[key] &&
          this.assets[key].color &&
          /^\#[A-F0-9]+$/i.test(this.assets[key].color)
          ? this.assets[key].color
          : color;
      });
    },
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: "Assets",
            data: this.data,
            backgroundColor: this.colors,
            borderColor: "#fff",
            borderWidth: 2,
          },
        ],
      };
    },
    options() {
      const custom = (emit) => (tooltipModel) => {
        emit("tooltip", tooltipModel);
      };
      return {
        aspectRatio: 1,
        showTooltips: false,
        legend: { display: false },
        animation: { duration: 0 },
        tooltips: {
          enabled: false,
          custom: custom(this.$emit.bind(this)),
        },
      };
    },
    assets() {
      return this.profitlossMode
        ? this.portfolioAssetsSortedByShare_pl
        : this.portfolioAssetsSortedByShare;
    },
    ...mapGetters({
      profitlossMode: "settings/profitlossMode",
      portfolioAssetsSortedByShare: "portfolio/portfolioAssetsSortedByShare",
      portfolioAssetsSortedByShare_pl:
        "profitloss/portfolioAssetsSortedByShare",
    }),
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
    /* When mounted will send legend html to parent,
      should legends be autogenerated in future? */

    /* eslint-disable no-underscore-dangle */
    // const legendHtml = this.$data._chart.generateLegend();
    // this.$emit('legend', legendHtml);
  },
  watch: {
    data() {
      this.$data._chart.destroy();
      this.renderChart(this.chartData, this.options);
      // const legendHtml = this.$data._chart.generateLegend();
      // this.$emit('legend', legendHtml);
    },
  },
};
</script>
